const communities = [
  { name: "Wentzville", dist: "10 min" },
  { name: "Lake Saint Louis", dist: "8 min" },
  { name: "St. Charles", dist: "12 min" },
  { name: "St. Peters", dist: "10 min" },
  { name: "Chesterfield", dist: "20 min" },
  { name: "Florissant", dist: "25 min" },
  { name: "Ballwin", dist: "25 min" },
  { name: "Troy", dist: "18 min" },
  { name: "Warrenton", dist: "28 min" },
];

const stats = [
  { value: "100K+", label: "O'Fallon metro area residents served" },
  { value: "24 hrs", label: "Fastest processing available" },
  { value: "30 min", label: "Drive saved to Downtown STL agency" },
  { value: "A+", label: "BBB Rating" },
];

export default function OFallonLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          <div>
            <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
            <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-5">
              O&apos;Fallon &amp; St. Charles County Passport Services
            </h2>
            <p className="text-gray-500 text-base leading-relaxed mb-6">
              O&apos;Fallon is Missouri&apos;s fastest-growing city and the anchor of the St. Charles County tech and military corridor. With Scott Air Force Base 20 miles southeast and a booming corporate campus district, international travel demands are constant. The St. Louis Regional Passport Agency is 30 minutes away — but walk-in emergency slots fill within minutes. We serve the entire western St. Louis metro corridor, including Wentzville, Lake Saint Louis, St. Charles, and St. Peters.
            </p>
            <div className="grid grid-cols-2 gap-4 mb-8">
              {stats.map((s, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-4">
                  <p className="font-bold text-2xl text-[#1A365D] mb-1">{s.value}</p>
                  <p className="text-gray-500 text-xs">{s.label}</p>
                </div>
              ))}
            </div>
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0f2240] text-white font-bold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
            >
              Start My Application <i className="ri-arrow-right-line"></i>
            </a>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-6 mb-6">
              <h3 className="font-bold text-[#1A365D] text-sm mb-4">Communities We Serve</h3>
              <div className="grid grid-cols-2 gap-3">
                {communities.map((c, i) => (
                  <div key={i} className="flex items-center justify-between bg-white rounded-md px-3 py-2">
                    <span className="text-gray-700 text-sm font-medium">{c.name}</span>
                    <span className="text-[#F6C344] text-xs font-semibold">{c.dist}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-[#1A365D] rounded-lg p-6 text-white">
              <h3 className="font-bold text-[#F6C344] text-sm mb-3">Why O&apos;Fallon Residents Choose Us</h3>
              <ul className="space-y-2.5">
                {[
                  "Military families at Scott AFB with PCS moves and deployment travel",
                  "Tech corridor employees flying to European offices via Lambert Airport",
                  "St. Charles County families heading to Cancun, Jamaica, and Caribbean",
                  "No scramble for limited STL agency emergency walk-in slots",
                  "Documents reviewed before submission — no costly rejections",
                ].map((item, i) => (
                  <li key={i} className="flex items-start gap-2.5 text-sm text-white/80">
                    <i className="ri-check-line text-[#F6C344] mt-0.5 flex-shrink-0"></i>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}